import { createEffect } from 'effector'
import toast from 'react-hot-toast'

import { toastView } from './view'

export const toastSuccessFx = createEffect<{ message: string }, void>(({ message }) => {
    toast.custom((toastData) => toastView({ toastData, message, variant: 'success' }), { duration: 2000 })
})

export const toastErrorFx = createEffect<{ message: string }, void>(({ message }) => {
    toast.custom((toastData) => toastView({ toastData, message, variant: 'error' }), {
        duration: Number.POSITIVE_INFINITY,
    })
})
